import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, ScrollView, Alert, ActivityIndicator } from 'react-native';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db, auth } from '../firebaseConfig';
import { MaterialCommunityIcons, MaterialIcons, Ionicons } from '@expo/vector-icons'; // Substituindo por @expo/vector-icons



const GainsScreen = ({ navigation }) => {
  const [gains, setGains] = useState([]);
  const [netGain, setNetGain] = useState(0);
  const [orderValueTotal, setOrderValueTotal] = useState(0);
  const [routeValueTotal, setRouteValueTotal] = useState(0);
  const [completedOrdersCount, setCompletedOrdersCount] = useState(0);
  const [dayGains, setDayGains] = useState(Array(7).fill(0));
  const [bairroTotal, setBairroTotal] = useState(0);
  const [setorTotal, setSetorTotal] = useState(0);
  const [extraTotal, setExtraTotal] = useState(0);
  const [weekRange, setWeekRange] = useState('');
  const [loading, setLoading] = useState(true);
  const daysOfWeek = ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'];

  useEffect(() => {
    navigation.setOptions({ headerShown: false });

    if (!auth.currentUser) {
      Alert.alert('Erro', 'Usuário não autenticado');
      return;
    }

    const calculateWeekRange = () => {
      const now = new Date();
      const dayOfWeek = now.getDay();
      const diffToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
      const startOfWeek = new Date(now);
      startOfWeek.setDate(now.getDate() - diffToMonday);
      startOfWeek.setHours(0, 0, 0, 0);

      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      endOfWeek.setHours(23, 59, 59, 999);

      setWeekRange(`${startOfWeek.toLocaleDateString('pt-BR')} - ${endOfWeek.toLocaleDateString('pt-BR')}`);
      return { startOfWeek, endOfWeek };
    };

    const { startOfWeek, endOfWeek } = calculateWeekRange();

    const fetchData = async () => {
      setLoading(true);
      try {
        const user = auth.currentUser;
        const qOrders = query(collection(db, 'pedido'), where('companyId', '==', user.uid), where('status', '==', 'completed'));
        const qRoutes = query(collection(db, 'routes'), where('companyId', '==', user.uid), where('status', '==', 'completed'));

        const ordersSnapshot = await getDocs(qOrders);
        const routesSnapshot = await getDocs(qRoutes);
        const orders = ordersSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        const routes = routesSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

        let combinedGains = [];
        let totalRouteValue = 0;
        let bairro = 0, setor = 0, extra = 0;

        // Processar pedidos concluídos
        orders.forEach((order) => {
          if (order.completedAt && order.orderValue && order.locationType) {
            const orderDate = new Date(order.completedAt.seconds * 1000);
            if (orderDate >= startOfWeek && orderDate <= endOfWeek) {
              const dayIndex = (orderDate.getDay() + 6) % 7;
              combinedGains.push({
                day: dayIndex,
                orderValue: parseFloat(order.orderValue) || 0,
              });

              // Acumular valores por tipo de localização
              if (order.locationType === 'Bairro') bairro += parseFloat(order.locationValue) || 0;
              if (order.locationType === 'Setor') setor += parseFloat(order.locationValue) || 0;
              if (order.locationType === 'Extra') extra += parseFloat(order.locationValue) || 0;
            }
          }
        });

        // Processar rotas concluídas
        routes.forEach((route) => {
          if (route.completedAt && route.totalValue) {
            const routeDate = new Date(route.completedAt.seconds * 1000);
            if (routeDate >= startOfWeek && routeDate <= endOfWeek) {
              const dayIndex = (routeDate.getDay() + 6) % 7;
              totalRouteValue += parseFloat(route.totalValue) || 0;

              route.orders.forEach((order) => {
                combinedGains.push({
                  day: dayIndex,
                  orderValue: parseFloat(order.orderValue) || 0,
                });

                // Acumular valores por tipo de localização
                if (order.locationType === 'Bairro') bairro += parseFloat(order.locationValue) || 0;
                if (order.locationType === 'Setor') setor += parseFloat(order.locationValue) || 0;
                if (order.locationType === 'Extra') extra += parseFloat(order.locationValue) || 0;
              });
            }
          }
        });

        const gainsByDay = Array(7).fill(0);
        combinedGains.forEach((gain) => {
          gainsByDay[gain.day] += gain.orderValue;
        });

        const totalOrderValue = combinedGains.reduce((sum, gain) => sum + gain.orderValue, 0);
        setOrderValueTotal(totalOrderValue);


        setGains(combinedGains);
        setDayGains(gainsByDay);
        setOrderValueTotal(totalOrderValue);
        setRouteValueTotal(totalRouteValue);
        setNetGain(totalOrderValue + totalRouteValue);
        setCompletedOrdersCount(combinedGains.length);

        // Atualizar estados de tipo de localização
        setBairroTotal(bairro);
        setSetorTotal(setor);
        setExtraTotal(extra);
      } catch (error) {
        console.error('Erro ao carregar os dados:', error);
        Alert.alert('Erro', 'Não foi possível carregar os dados.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const formatCurrency = (value) => {
    return `R$ ${value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  if (loading) {
    return (
      <View style={styles.container}>
        <ActivityIndicator size="large" color="#FFF" />
      </View>
    );
  }

  return (
    <ScrollView 
  contentContainerStyle={styles.scrollContainer} 
  style={styles.fullScreen}
  showsVerticalScrollIndicator={false}
>
  <View style={styles.container}>

  <TouchableOpacity style={styles.backButtonContainer} onPress={() => navigation.goBack()}>
    <MaterialIcons name="arrow-back" size={24} color="#FFF" />
  </TouchableOpacity>

  {/* Exibe o intervalo de datas */}
  <Text style={styles.dateRange}>{weekRange}</Text>

  {/* Valor total dos pedidos */}
  <Text style={styles.totalGain}>{formatCurrency(orderValueTotal)}</Text>

  {/* Gráfico de barras */}
  <View style={styles.chartContainer}>
    {dayGains.map((gain, index) => (
      <View key={index} style={styles.barWrapper}>
        <View style={styles.barContainer}>
          <View
            style={[
              styles.bar,
              { height: (Math.min(gain, 10000) / 10000) * 200 || 0 },
            ]}
          />
          <Text
            style={[
              styles.barValue,
              { bottom: (Math.min(gain, 10000) / 10000) * 200 + 5 },
            ]}
          >
            {formatCurrency(gain)}
          </Text>
        </View>
        <Text style={styles.barLabel}>{daysOfWeek[index]}</Text>
      </View>
          ))}
        </View>

        <View style={styles.detailContainer}>
          <Text style={styles.detailItem}>Pedidos concluídos: {completedOrdersCount}</Text>
          <Text style={styles.detailItem}>Valor total dos pedidos: {formatCurrency(orderValueTotal)}</Text>
          <Text style={styles.detailItem}>Total Bairro: {formatCurrency(bairroTotal)}</Text>
          <Text style={styles.detailItem}>Total Setor: {formatCurrency(setorTotal)}</Text>
          <Text style={styles.detailItem}>Total Extra: {formatCurrency(extraTotal)}</Text>
        </View>

        <TouchableOpacity style={styles.detailedGainsButton} onPress={() => navigation.navigate('DetailedGainsScreen')}>
          <Text style={styles.detailedGainsButtonText}>Ganhos Detalhados</Text>
        </TouchableOpacity>

        <TouchableOpacity style={styles.historyButton} onPress={() => navigation.navigate('GainsHistoryScreen')}>
          <Text style={styles.historyButtonText}>Histórico de Ganhos</Text>
        </TouchableOpacity>
      </View>
    </ScrollView>
  );
};
const styles = StyleSheet.create({
  scrollContainer: {
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 50, // Garante espaço extra no final para evitar corte
  },
  fullScreen: {
    flex: 1,
    backgroundColor: '#2c5364', // Fundo expandido para toda a tela
    width: '100%',
  },
  container: {
    flex: 1,
    width: '100%',
    backgroundColor: '#2c5364', // Fundo azul expandido
    paddingTop: 40,
    paddingBottom: 40,
    paddingHorizontal: 16,
    justifyContent: 'center',
    alignItems: 'center',
  },
  backButtonContainer: {
    alignSelf: 'flex-start',
    marginBottom: 20,
    backgroundColor: '#203a43', // Fundo escuro
    padding: 10,
    borderRadius: 50,
    shadowColor: '#000',
    shadowOpacity: 0.3,
    shadowRadius: 10,
    shadowOffset: { width: 0, height: 5 },
    elevation: 5,
  },
  dateRange: {
    fontSize: 18,
    color: '#00FF9D', // Verde neon para o intervalo de datas
    textAlign: 'center',
    marginTop: 8,
  },
  totalGain: {
    fontSize: 30,
    fontWeight: 'bold',
    color: '#00FF9D', // Verde neon para destaque
    textAlign: 'center',
    marginVertical: 12,
  },
  chartContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    height: 200,
    width: '100%',
    marginVertical: 16,
  },
  barWrapper: {
    alignItems: 'center',
    width: 48,
  },
  barContainer: {
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: '100%',
    position: 'relative',
    width: 48,
  },
  bar: {
    backgroundColor: '#00FF9D', // Verde neon para as barras
    width: 16,
    borderRadius: 4,
    shadowColor: '#00FF9D',
    shadowOpacity: 0.8,
    shadowRadius: 10,
    shadowOffset: { width: 0, height: 0 },
    elevation: 5,
  },
  barLabel: {
    color: '#FFF', // Branco para o texto
    marginTop: 8,
    fontSize: 12,
  },
  barValue: {
    color: '#00FF9D', // Verde neon para os valores
    position: 'absolute',
    fontSize: 12,
    textAlign: 'center',
    bottom: -20,
  },
  detailContainer: {
    backgroundColor: '#203a43', // Fundo escuro
    borderRadius: 12,
    padding: 16,
    marginVertical: 24,
    alignItems: 'flex-start',
    width: '95%', // Ajustado para melhor alinhamento
    maxWidth: 900, // Evita que fique muito grande em telas largas
    shadowColor: '#00FF9D',
    shadowOpacity: 0.7,
    shadowRadius: 10,
    shadowOffset: { width: 0, height: 5 },
    elevation: 5,
  },
  detailItem: {
    fontSize: 18,
    color: '#00FF9D', // Verde neon para detalhes
    marginBottom: 12,
  },
  historyButton: {
    backgroundColor: '#00FF9D', // Botão verde neon
    padding: 15,
    borderRadius: 8,
    alignItems: 'center',
    marginVertical: 20,
    width: '90%',
    shadowColor: '#00FF9D',
    shadowOpacity: 0.8,
    shadowRadius: 10,
    shadowOffset: { width: 0, height: 5 },
    elevation: 5,
  },
  historyButtonText: {
    color: '#203a43', // Fundo escuro para contraste com o botão
    fontSize: 18,
    fontWeight: 'bold',
  },
  detailedGainsButton: {
    backgroundColor: '#00FF9D', 
    padding: 15,
    borderRadius: 8,
    alignItems: 'center',
    marginBottom: 10, // Espaço entre os botões
    width: '90%',
    shadowColor: '#00FF9D',
    shadowOpacity: 0.8,
    shadowRadius: 10,
    shadowOffset: { width: 0, height: 5 },
    elevation: 5,
  },
  detailedGainsButtonText: {
    color: '#203a43',
    fontSize: 18,
    fontWeight: 'bold',
  },
  
});

export default GainsScreen;
